import DeviceManager from '../utils/device-manager';
import Swiper, { SwiperOptions } from 'swiper';

type QualificationsCarouselType = {
    $swipers: NodeListOf<HTMLElement>|null,
    swipers: { [key: string]: Swiper },
    init(): void,
    initSwiper($swiper: HTMLElement, name: string): void,
};

const QualificationsCarousel: QualificationsCarouselType = {
    $swipers: null,
    swipers: {},

    init() : void {
        this.$swipers = document.querySelectorAll<HTMLElement>('.qualifications-carousel-swiper');

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index.toString());
        });
    },

    initSwiper($swiper: HTMLElement, name: string) : void {
        const args: SwiperOptions = {
            updateOnWindowResize: true,
            slidesPerView: 'auto',
            loop: false,
            allowTouchMove: true,
            threshold: 10,
            spaceBetween: 27,
            breakpoints: {
                [DeviceManager.devices.lg]: {
                    spaceBetween: 45,
                },
            },
        };

        DeviceManager.addCallback(attr => {
            if (!DeviceManager.isGreaterThanOrEqual(attr.current, 'lg')) { // Mobile
                this.swipers[name] = new Swiper($swiper, args);
            } else { // Large desktop
                this.swipers[name].destroy();
            }
        });
    },
};

export default QualificationsCarousel;
